import { useAppState } from "@/store/useApp";

interface OnboardingFlowProps {
  children: React.ReactNode;
}

const OnboardingFlow = ({ children }: OnboardingFlowProps) => {
  const onboardingCompleted = useAppState(
    (state) => state.user?.onboardingCompleted ?? false
  );

  console.log("onboardingCompleted", onboardingCompleted);

  if (onboardingCompleted) {
    return null;
  }

  return children;
}

export default OnboardingFlow;